
namespace RioERP.Common {

    @Serenity.Decorators.registerClass()
    export class SMSGrid extends Serenity.EntityGrid<SMSRow, any> {
        protected getColumnsKey() { return SMSColumns.columnsKey; }
        protected getDialogType() { return SMSDialog; }
        protected getIdProperty() { return SMSRow.idProperty; }
        protected getInsertPermission() { return SMSRow.insertPermission; }
        protected getLocalTextPrefix() { return SMSRow.localTextPrefix; }
        protected getService() { return SMSService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}